import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { decodeHTML } from "@utils/CommonUtils";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useDocumentDetails } from "~/Modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { post, put } from "~/Services";
import { eramanHost } from "~/Utils";
import { fields } from "../constants";
import { useAdsNewsDocumentDetails } from "./hooks/AdsBanner.hook";

export const AddEditAdsNews = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();

  // editId flow (master data)
  const {
    data: newsData,
    isLoading: newsLoading,
    refetch: refetchNews,
  } = useAdsNewsDocumentDetails(query.get("editId") || "");

  // id flow (draft/submitted doc details)
  const { data: newsById, isLoading: docLoading, refetch: refetchDoc } = useDocumentDetails(query.get("id") || "");

  useEffect(() => {
    if (query.get("editId")) {
      refetchNews();
    } else {
      refetchNews();
    }
    if (query.get("id")) {
      refetchDoc();
    }
  }, [query.get("editId"), query.get("id")]);

  console.log("newsById", newsById, "newsData", newsData);

  const brandFromFields: FormConfig = {
    initialValues: {
      field_english_title: decodeHTML(newsById?.payload?.field_english_title ?? newsData?.field_english_title ?? ""),
      // field_malay_title: decodeHTML(newsById?.payload?.field_malay_title ?? newsData?.field_malay_title ?? ""),
      // field_mandarin_title: decodeHTML(newsById?.payload?.field_mandarin_title ?? newsData?.field_mandarin_title ?? ""),

      field_malay_title: decodeHTML(
        typeof (newsById?.payload?.field_malay_title ?? newsData?.field_malay_title) === "string"
          ? (newsById?.payload?.field_malay_title ?? newsData?.field_malay_title)
          : ""
      ),

      field_mandarin_title: decodeHTML(
        typeof (newsById?.payload?.field_mandarin_title ?? newsData?.field_mandarin_title) === "string"
          ? (newsById?.payload?.field_mandarin_title ?? newsData?.field_mandarin_title)
          : ""
      ),
      // published: newsById?.payload?.published ?? newsData?.published ?? false,
    },
    fields: fields.bannerNews,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let imageKeys: any = [];
    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field[0]?.originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "ERAMAN");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            data[key] = res.response.data;
          }
        } else {
          data[key] = data[key][0]?.url;
        }
      } catch (error) {}
    }

    const payload = {
      action,
      method,
      module: "Advertisement",
      subModule: "bannerNews",
      type: "DEDICATED",
      application: "ERAMAN",
      reviewNotes,
      appList: [
        {
          appName: "ERAMAN",
          apiUrl,
        },
      ],
      payload: {
        ...(action === "UPDATE" && {
          id: newsData?.tid || newsById?.payload?.tid,
        }),
        ...data,
        status: true,
      },
      status,
    };

    console.log("Final Payload (News):", payload);

    if (query.get("id")) {
      // draft/submitted doc update flow
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch(() => {
          openToast({
            content: "Failed to save Data",
            type: "error",
          });
        });
    } else {
      // editId flow
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data Saved Successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch(() => {
          openToast({
            content: "Failed to create News",
            type: "error",
          });
        });
    }
  };

  return (
    <DynamicForm
      isLoading={newsLoading || docLoading}
      config={brandFromFields}
      onSubmit={(data, buttonValue, reviewNotes) =>
        onSubmit(
          data,
          `${eramanHost}/api/news-products-banner-update-api/${newsData?.tid || newsById?.payload?.tid}`,
          query.get("editId") ? "UPDATE" : "UPDATE",
          query.get("editId") ? "PATCH" : "PATCH",
          buttonValue === "save" ? "DRAFT" : "PENDING",
          reviewNotes
        )
      }
    />
  );
};
